import { ApplicationConfig, importProvidersFrom ,provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara'; // You can choose other presets like Material, Lara, or Nora
import { initSentry } from './sentry.config';
import { errorInterceptor } from '../services/error.interceptor';
import { GlobalErrorHandler } from '../services/global-error.handler';
import { ErrorHandler } from '@angular/core';
import { ProductAnalyticService } from '../services/product-analytic.service';

// Initialize Sentry
initSentry();

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([errorInterceptor])
    ),
    provideAnimations(), // Required for animations
    providePrimeNG({
      theme: {
        preset: Lara,
        options: {
          colorScheme: 'light-blue'  // or 'dark-blue', 'light-indigo', etc.
        }
      }
    }),
    provideToastr({
      positionClass: 'toast-top-center',
      timeOut: 3000,
    }),
    // Add global error handler
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    // Product Analytics Service
    ProductAnalyticService,
  ]
};
